import { defineStore } from 'pinia';
import CmsSettingsService, { type ThemeSettings } from '../services/CmsSettingsService';

export const useSettingsStore = defineStore('plugin:settings', () =>
{
    const config = CmsSettingsService.getConfig();
    const themes: Record<string, Promise<ThemeSettings>> = {};

    async function $settings(name: string, throwError: boolean = false)
    {
        return new Promise((resolve, reject) =>
        {
            config
                .then((config: any) => resolve(config[name] || {}))
                .catch((reason) =>
                {
                    console.error(`An error occurred while loading settings (${name}).`);

                    if (throwError)
                        reject(reason);
                    else
                        resolve(null);
                });
        });
    }

    function $theme(name: string, throwError: boolean = false)
    {
        return themes[name] || (themes[name] = new Promise((resolve, reject) =>
        {
            CmsSettingsService.getThemeConfig(name)
                .then(config => resolve(config))
                .catch((reason) =>
                {
                    console.error(`An error occurred while loading theme settings (${name}).`);

                    if (throwError)
                        reject(reason);
                    else
                        resolve(null);
                });
        }));
    }

    return { $settings, $theme };
});
